import { render, staticRenderFns } from "./productOne.vue?vue&type=template&id=7c3bf073&"
import script from "./productOne.vue?vue&type=script&lang=js&"
export * from "./productOne.vue?vue&type=script&lang=js&"
import style0 from "./productOne.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/toutiao/productOne.vue
// module id = null
// module chunks = 